export default "__VITE_ASSET__DveTx1Dy__"